// src/new/components/monitor/TriageChat/TriageChatRoute.tsx
import React from 'react';
import { useLocation } from 'react-router-dom';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';
import { buildTriageContextFromParams } from './triageContext';
import { TriageChatContainer } from './TriageChatContainer';

export const TriageChatRoute: React.FC & { screenConfig?: any } = () => {
  const location = useLocation();
  const context = buildTriageContextFromParams(new URLSearchParams(location.search));

  if (!context) {
    return (
      <div data-testid="triage-route-error" style={{ padding: 'var(--spacing-xl)' }}>
        <h2>Triage chat</h2>
        <p>Missing or invalid resource id in the link.</p>
        <a href={`${ROUTE_REDESIGN}/monitor/runs`}>Back to Monitor</a>
      </div>
    );
  }

  return (
    <div style={{ height: 'calc(100vh - 120px)', padding: 'var(--spacing-lg)' }}>
      <TriageChatContainer context={context} />
    </div>
  );
};

TriageChatRoute.screenConfig = {
  path: `${ROUTE_REDESIGN}/monitor/triage-chat`,
  domain: 'monitor',
  header: {
    title: 'Triage Chat',
    slugTitle: 'Triage Chat',
  },
  screenName: 'TriageChatRoute',
};

export default TriageChatRoute;
